import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Package, Zap } from 'lucide-react';
export function ProductIntro() {
  return <section className="w-full px-4 py-20 md:py-24 bg-bg-primary" data-id="element-255">
      <div className="max-w-5xl mx-auto text-center" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-257">
          <div className="inline-block mb-6 px-6 py-3 bg-orange/10 border border-orange rounded-full text-orange font-bold" data-id="element-258">
            🏆 El Sistema N°1 para Entrenadores de Vóley Argentinos
          </div>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4" data-id="element-259">
            VOLEY 360 — Colección Completa
          </h2>

          <p className="text-xl md:text-2xl text-text-secondary mb-12" data-id="element-260">
            12 Tomos + 6 Bonus + 2 Élite — Todo resuelto, todas las categorías.
          </p>

          <div className="flex flex-wrap justify-center gap-4" data-id="element-261">
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-262">
              <FileText className="w-5 h-5 text-orange" data-id="element-263" />
              <span className="font-medium" data-id="element-264">+280 páginas</span>
            </div>
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-265">
              <Package className="w-5 h-5 text-orange" data-id="element-266" />
              <span className="font-medium" data-id="element-267">+200 ejercicios graficados</span>
            </div>
            <div className="px-6 py-3 bg-bg-card border border-border-card rounded-full flex items-center gap-2" data-id="element-268">
              <Zap className="w-5 h-5 text-orange" data-id="element-269" />
              <span className="font-medium" data-id="element-270">Todas las categorías</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}